import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button, Container, Dropdown } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import DatasetUtils from "../../services/DatasetUtils";
import Arrow from "../../assets/Arrow.svg"
import Filter_A_Z from "../../assets/Filter_AZ.svg"
// import FindIcon from "../../assets/FindIcon.svg"
import DataIcon from "../../assets/datainfo_icon.svg"
import ChainIcon from "../../assets/chain_icon.svg"
import MenuIcon from "../../assets/menudots_icon.svg"
import TableIcon from '../../assets/table_icon.svg'
import MapIcon from '../../assets/map_icon.svg'
import "./styles.scss"
import { useNavigate } from 'react-router-dom'
import DecomposerIcon from "../../assets/decomposerIcon.svg"
import NormaliserIcon from "../../assets/normaliserIcon.svg"
import GeometryIcon from "../../assets/geometryIcon.svg"
import MetadataIcon from "../../assets/metadata_icon.svg"
import CloseCross from "../../assets/closeCross.svg"
import Publisher from '../Publisher';
import Decomposer from '../../actions/Decomposer';
import Normaliser from '../../actions/Normaliser';
import Connector from '../../actions/Connector';
import GeometryTransformer from '../../actions/GeometryTransformer';

export default function MyDatasets(props) {
    const navigation = useNavigate() // extract navigation prop here 
    return <MyDatasetsClass {...props} navigation={navigation} /> //pass to your component.

}


var SORT_DATABASES = {
    date_91: "По дате",
    date_19: "По дате",
    name_91: "По имени",
    name_19: "По имени",
};
class MyDatasetsClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            myDatasets: null,
            allDatasets: null,
            datasetForDelete: null,
            filteringText: null,
            connector: false,
            decomposer: false,
            normaliser: false,
            geometryTransformer: false,
            publisher: false,
            sortingValue: localStorage.getItem("sortingValue") ? localStorage.getItem("sortingValue") : 'date_91',
            forPublication: false,
            choosenDataset: null,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        this.startLoading();
        this.getData();
        this.dataInterval = setInterval(() => {
            console.log('get new data')
            this.getData();
        }, 10000);
    }
    componentWillUnmount() {
        this.dataInterval && clearInterval(this.dataInterval)
    }
    getData = () => {
        ApiService.getMyDatasets().then((response) => {
            if (this.checkStatus(response)) {
                this.setState({
                    allDatasets: response.datasets,
                }, () => {
                    // response.datasets.forEach((dataset)=>{
                    //     if (dataset.create && dataset.create.time)
                    //     {
                    //         dataset.date = dataset.create.time.$date.$numberLong
                    //     }
                    //     //else // dataset.date = dataset.create.time.$date.$numberLong
                    //     //console.log(dataset.create.time.$date.$numberLong)
                    // })
                    if (this.state.filteringText !== null) this.filteringDatasets(this.state.filteringText)
                    else this.setState({ myDatasets: this.changeSorting(response.datasets) })
                });
            }
            this.stopLoading();
        });
    }

    filteringDatasets = (text) => {
        let filtered = []
        this.state.allDatasets.forEach(dataset => {
            if (dataset.name.toLowerCase().includes(text.toLowerCase())) {
                filtered.push(dataset)
            }
        })
        this.setState({ filteringText: text, myDatasets: this.changeSorting(filtered) })
    }
    confirmDeleteDataset = (dataset) => {

        ApiService.deleteLKDataset(dataset.dataset).then((response) => {
            if (this.checkStatus(response)) {
                let myDatasets = this.state.myDatasets;
                let index = myDatasets.indexOf(dataset);
                if (index >= 0) {
                    myDatasets.splice(index, 1);
                }
                this.setState({
                    myDatasets: myDatasets,
                    datasetForDelete: null
                });
            }
            this.stopLoading();
        });
        // if (this.state.datasetForDelete === dataset) {

        //     ApiService.deleteLKDataset(dataset.dataset).then((response) => {
        //         if (this.checkStatus(response)) {
        //             let myDatasets = this.state.myDatasets;
        //             let index = myDatasets.indexOf(dataset);
        //             if (index >= 0) {
        //                 myDatasets.splice(index, 1);
        //             }
        //             this.setState({
        //                 myDatasets: myDatasets,
        //                 datasetForDelete: null
        //             });
        //         }
        //         this.stopLoading();
        //     });

        // }
        // else {
        //     this.setState({
        //         datasetForDelete: dataset
        //     });
        // }
    }

    byField = (field) => {
        return (a, b) => a[field] > b[field] ? 1 : -1;
    }
    byFieldDown = (field) => {
        return (a, b) => a[field] > b[field] ? -1 : 1;
    }
    changeSorting = (datasets) => {
        let newDataset = datasets

        if (this.state.forPublication) {

            newDataset = []
            datasets.forEach((dataset, i) => {
                console.log(dataset)
                if (dataset.state && dataset.state.properties && dataset.state.properties.has_geometry) {
                    newDataset.push(dataset)
                }

            })
        }
        else {
            let filtered = []
            if (this.state.filteringText) this.state.allDatasets.forEach(dataset => {
                if (dataset.name.toLowerCase().includes(this.state.filteringText.toLowerCase())) {
                    filtered.push(dataset)
                }
            })
            else filtered = this.state.allDatasets

            newDataset = filtered
        }

        if (this.state.sortingValue) {
            if (this.state.sortingValue.split('_')[0] === 'name' && datasets) {

                if (this.state.sortingValue.split('_')[1] === '19') {
                    newDataset = datasets.sort(this.byField('name'))
                }
                else {
                    newDataset = datasets.sort(this.byFieldDown('name'))
                }
            }
            else {
                let emptyDate = []
                let withDate = []
                newDataset.forEach((dataset, i) => {
                    if (!dataset.dateOfCreating) {
                        if (dataset.create && dataset.create.time.$date.$numberLong) {
                            dataset.dateCreate = dataset.create.time.$date.$numberLong
                            withDate.push(dataset)
                        }
                        else emptyDate.push(dataset)
                    }
                })

                if (this.state.sortingValue.split('_')[1] === '19') {
                    newDataset = withDate.sort(this.byField('dateCreate'))
                }
                else {
                    newDataset = withDate.sort(this.byFieldDown('dateCreate'))
                }

                newDataset = [...withDate, ...emptyDate]
            }
        }

        return newDataset
    }

    updateDatasetState = (newDataset) => {
        this.setState({ myDatasets: newDataset })
    }


    render() {
        let myDatasets = this.state.myDatasets;

        if (myDatasets) {
            for (let i = 0; i < myDatasets.length; i++) {
                let history = [];
                if ((myDatasets[i].create && myDatasets[i].create.status)) {
                    history.push({ event: "создан", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].create.time["$date"]["$numberLong"]))) });
                }
                if ((myDatasets[i].import && myDatasets[i].import.status)) {
                    history.push({ event: "импортирован", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].import.time["$date"]["$numberLong"]))) });
                }
                if ((myDatasets[i].addGeometry && myDatasets[i].addGeometry.status)) {
                    history.push({ event: "оснащен геометрией", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].addGeometry.time["$date"]["$numberLong"]))) });
                }
                if ((myDatasets[i].addressDecomposed && myDatasets[i].addressDecomposed.status)) {
                    history.push({ event: "разобран адрес", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].addressDecomposed.time["$date"]["$numberLong"]))) });
                }
                if ((myDatasets[i].connect && myDatasets[i].connect.status)) {
                    history.push({ event: "связан", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].connect.time["$date"]["$numberLong"]))) });
                }
                if ((myDatasets[i].publicate && myDatasets[i].publicate.status)) {
                    history.push({ event: "опубликован", time: ApiService.prettyDateTime(new Date(parseInt(myDatasets[i].publicate.time["$date"]["$numberLong"]))) });
                }
                myDatasets[i].history = history;

                if (!myDatasets[i].fields) {
                    myDatasets[i].fields = [];
                }
                myDatasets[i].hasGeometry = (DatasetUtils.unsetGeometryFeatures(myDatasets[i].fields).length === 0);
                myDatasets[i].hasAddressParts = (DatasetUtils.unsetAddressFeatures(myDatasets[i].fields).length === 0);
                myDatasets[i].hasAllFeatures = (DatasetUtils.unsetConnectingByGeometryFeatures(myDatasets[i].fields).length === 0) || (DatasetUtils.unsetConnectingByAddressFeatures(myDatasets[i].fields).length === 0);
            }

        }

        let exitCross = () => {
            return <img className='exitCross' src={CloseCross} onClick={() => {
                this.setState({
                    normaliser: false,
                    connector: false,
                    decomposer: false,
                    publisher: false,
                    geometryTransformer: false,
                })
            }} alt='CloseCross' />
        }

        let getMainAction = (dataset) => {
            if (!dataset.state || !dataset.state.properties) {
                return {
                    label: "посмотреть",
                    action: () => { this.goToSection(this.props.navigation, "DatasetTable", { DT_dataset: dataset }) }
                }
            }
            else {
                if (dataset.state.properties.connected) {
                    if (dataset.state.properties.published) {
                        if (dataset.state.properties.enriched) {
                            return {
                                label: "экспортировать",
                                action: () => { this.goToSection(this.props.navigation, "DatasetTable", { DT_dataset: dataset }) }
                            }
                        }
                        else {
                            return {
                                label: "обогатить по ОАП",
                                action: () => { this.goToSection(this.props.navigation, "TuneMetadata", { TM_dataset: dataset }) }
                            }
                        }
                    }
                    else {
                        return {
                            label: "опубликовать на карту",
                            action: () => { this.setState({ publisher: true, choosenDataset: dataset }) }
                        }
                    }
                }
                else {
                    if (dataset.state.properties.has_geometry || dataset.state.properties.has_address) {
                        return {
                            label: "обработать геометрию",
                            action: () => { this.setState({ geometryTransformer: true, choosenDataset: dataset }) }
                        }

                    }
                    else {
                        if (dataset.state.properties.has_address_features) {
                            return {
                                label: "разобрать адреса",
                                action: () => { this.setState({ decomposer: true, choosenDataset: dataset }) }
                            }
                        }
                        else {
                            return {
                                label: "выбрать признаки",
                                action: () => { this.goToSection(this.props.navigation, "TuneMetadata", { TM_dataset: dataset }) }
                            }
                        }
                    }
                }
            }
        }

        return (<>
            {this.state.normaliser && this.state.choosenDataset && <Normaliser choosenDataset={this.state.choosenDataset} />}
            {this.state.connector && this.state.choosenDataset && <Connector choosenDataset={this.state.choosenDataset} />}
            {this.state.decomposer && this.state.choosenDataset && <Decomposer choosenDataset={this.state.choosenDataset} />}
            {this.state.publisher && this.state.choosenDataset && <Publisher choosenDataset={this.state.choosenDataset} />}
            {this.state.geometryTransformer && this.state.choosenDataset && <GeometryTransformer choosenDataset={this.state.choosenDataset} />}
            {(this.state.normaliser || this.state.connector || this.state.decomposer || this.state.publisher || this.state.geometryTransformer) && exitCross()}
            <div id="myDatasets" className="flexColumn rightPanel">
                {this.renderAlerts()}
                <div className="headerContainer">
                    <div className='titleContainer'><p className="headerMargin">Загруженные наборы</p>
                        <Button variant="primary" className="importMyDataDataset" onClick={() => { this.goToSection(this.props.navigation, "ImportDataset"); }}>Добавить файл</Button>
                    </div>
                    <div className='inputContainer'><input id='inputContainerDatasets' className='inputStyle textRoboto' placeholder="Найти..." onChange={e => this.filteringDatasets(e.target.value)} /><div className='nopeFiltering' onClick={e => {
                        this.filteringDatasets('')
                        let input = document.getElementById('inputContainerDatasets')
                        if (input && input.value) input.value = ''
                    }
                    }><img className='filter-icon' src={CloseCross} alt='find icon' /></div>
                    </div>
                </div>
                <div className="postHeaderContainer textRoboto">

                    <p>Сортировать:</p>
                    <Dropdown className="sortButton">
                        <Dropdown.Toggle className="dropdownButtonSort textRoboto" variant="success" id="dropdown-basic">
                            <p>{this.state.sortingValue ? SORT_DATABASES[this.state.sortingValue] : "Выберите тип сортировки"}</p>
                            <img className={this.state.sortingValue.split('_')[1] === '19' ? 'dropArrow' : 'dropArrow downMirrow'} src={Filter_A_Z} alt='dropArrow' />
                            <img className='dropArrow' src={Arrow} alt='dropArrow' />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {Object.entries(SORT_DATABASES).map((typeArray, index) => (
                                <Dropdown.Item key={index} onClick={() => {
                                    this.setState({ sortingValue: typeArray[0] }, () => { this.updateDatasetState(this.changeSorting(this.state.myDatasets)) });
                                }}>
                                    {typeArray[1]}
                                    <img className={typeArray[0].split('_')[1] === '19' ? 'dropArrow' : 'dropArrow downMirrow'} src={Filter_A_Z} alt='dropArrow' />
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <input type="checkbox" id="switch" onChange={(e) => { this.setState({ forPublication: e.target.checked }, () => { this.updateDatasetState(this.changeSorting(this.state.myDatasets)) }) }} /><label htmlFor="switch" id='switchLabel'>Toggle</label><p>Только «Готовые для публикации»</p>
                </div>

                <Container className="containerListStyle">
                    {this.state.myDatasets ?
                        (
                            this.state.myDatasets.length > 0 ? this.state.myDatasets.map((dataset) => {
                                let lineButtonResult = this.getPropertiesForButtonsList(dataset);
                                return <div key={dataset._id["$oid"]} className={"inMyDataBlocks"}>
                                    <div className='dataset-name-line'>
                                        <div className={'datasetMyDataName'}>
                                            {dataset.name}
                                        </div>

                                        <Dropdown className="">
                                            <Dropdown.Toggle className="delButton textRoboto" variant="success" id="dropdown-basic">
                                                <img className='dataset-info-icon cursor-pointer' src={MenuIcon} onClick={() => console.log('open menu')} alt='MenuIcon' />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>

                                                <Dropdown.Item className='delItem' onClick={() => {
                                                    this.confirmDeleteDataset(dataset)
                                                }}>
                                                    Удалить
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>


                                        {/* <div className='dataset-dropmenu'>
                                    <p className='dataset-dropmenu-item'>Хроника</p>
                                    <p className='dataset-dropmenu-item-colored'>Удалить</p>
                                </div> */}
                                    </div>
                                    <div className='dataset-info-lines'>
                                        {dataset.history && (dataset.history.length > 0) &&
                                            <div className='dataset-info-dataline'>
                                                <img className='dataset-info-icon' src={DataIcon} alt='dataicon' />
                                                <p className='dataset-info-dataline-p'>{dataset.history[0].event}: {dataset.history[0].time}</p>
                                            </div>
                                        }

                                        <div className='dataset-info-infoline'>
                                            {!lineButtonResult.nothing && <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.goToSection(this.props.navigation, "TuneMetadata", { TM_dataset: dataset }) }}>
                                                <img className='dataset-info-icon' src={MetadataIcon} alt='MetadataIcon' />
                                                <p className='dataset-info-infoline-p'> настроить структуру </p>
                                            </div>}

                                            {/* пока что для всех наборов, у кого не проставлено состояние датасета, будут предлагаться все кнопки */}
                                            {lineButtonResult.decomposer &&
                                                <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.setState({ decomposer: true, choosenDataset: dataset }) }}>
                                                    <img className='dataset-info-icon' src={DecomposerIcon} alt='DecomposerIcon' />
                                                    <p className='dataset-info-infoline-p'> разобрать адреса </p>
                                                    {lineButtonResult.decomposerNotify &&
                                                        <img className='dataset-info-notify' src={lineButtonResult.decomposerNotify} alt='notify' />
                                                    }
                                                </div>
                                            }
                                            {lineButtonResult.normaliser &&
                                                <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.setState({ normaliser: true, choosenDataset: dataset }) }}>
                                                    <img className='dataset-info-icon' src={NormaliserIcon} alt='ChainIcon' />
                                                    <p className='dataset-info-infoline-p'> нормализовать адреса </p>
                                                    {lineButtonResult.normaliserNotify &&
                                                        <img className='dataset-info-notify' src={lineButtonResult.normaliserNotify} alt='notify' />
                                                    }
                                                </div>
                                            }
                                            {lineButtonResult.connector &&
                                                <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.setState({ connector: true, choosenDataset: dataset }) }}>
                                                    <img className='dataset-info-icon' src={ChainIcon} alt='ChainIcon' />
                                                    <p className='dataset-info-infoline-p'> связать с ОАП </p>
                                                    {lineButtonResult.connectorNotify &&
                                                        <img className='dataset-info-notify' src={lineButtonResult.connectorNotify} alt='notify' />
                                                    }
                                                </div>
                                            }
                                            {lineButtonResult.publisher &&
                                                <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.setState({ publisher: true, choosenDataset: dataset }) }}>
                                                    <img className='dataset-info-icon' src={MapIcon} alt='MapIcon' />
                                                    <p className='dataset-info-infoline-p'> опубликовать на карту </p>
                                                    {lineButtonResult.publisherNotify &&
                                                        <img className='dataset-info-notify' src={lineButtonResult.publisherNotify} alt='notify' />
                                                    }
                                                </div>
                                            }
                                            {lineButtonResult.geometryTransformer &&
                                                <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.setState({ geometryTransformer: true, choosenDataset: dataset }) }}>
                                                    <img className='dataset-info-icon' src={GeometryIcon} alt='ChainIcon' />
                                                    <p className='dataset-info-infoline-p'> обработать геометрию </p>
                                                    {lineButtonResult.geometryTransformerNotify &&
                                                        <img className='dataset-info-notify' src={lineButtonResult.geometryTransformerNotify} alt='notify' />
                                                    }
                                                </div>
                                            }
                                            {lineButtonResult.nothing &&
                                                <div className='dataset-info-infoline-line' onClick={() => { }}>
                                                    {dataset.database &&
                                                        <p className='dataset-info-dataline-cursive'>Это общедоступный набор данных, вы можете смотреть его, делать выборки и скачивать.</p>
                                                    }
                                                    {!dataset.database &&
                                                        <p className='dataset-info-dataline-cursive'>Набор недавно загружен и еще готовится, скоро он станет доступен для обработки. Пока что можете только смотреть.</p>
                                                    }
                                                </div>
                                            }
                                            {!lineButtonResult.nothing && <div className='dataset-info-infoline-line cursor-pointer' onClick={() => { this.goToSection(this.props.navigation, "DatasetTable", { DT_dataset: dataset }) }}>
                                                <img className='dataset-info-icon' src={TableIcon} alt='TableIcon' />
                                                <p className='dataset-info-infoline-p'> посмотреть таблицу </p>
                                            </div>}
                                        </div>
                                    </div>

                                    <div className='dataset-info-footer' onClick={getMainAction(dataset).action}>
                                        <div className='dataset-info-footer-button cursor-pointer'>
                                            <p className='dataset-info-footer-button-p'>{getMainAction(dataset).label}</p>
                                        </div>
                                    </div>
                                </div>
                            })
                                :
                                <div className={"inMyDataBlocks"}>
                                    <div className='dataset-name-line'>
                                    </div>
                                    <div className='dataset-info-infoline'>
                                        <div className='dataset-info-lines'>

                                            <div className='dataset-info-infoline-line' onClick={() => { }}>
                                                <p className='dataset-info-dataline-cursive'>Создайте свой первый набор данных. Принимаются форматы Excel и GeoJSON.</p>

                                            </div>

                                            <Button variant="primary" className="importMyDataDataset bigImportButton" onClick={() => { this.goToSection(this.props.navigation, "ImportDataset"); }}>Добавить файл</Button>

                                        </div>
                                    </div>
                                </div>
                        )
                        :
                        <div className={"inMyDataBlocks moth"}>
                            <div className='loader'></div>
                        </div>
                    }
                </Container>
                {this.state.message}
            </div ></>
        );
    }
}